define("media/models/flatpickr-config", ["exports", "@ember/debug"], function (_exports, _debug) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  /**
   * @class FlatpickrConfig
   * Config object to set up a flatpickr instance. This provides an interface for flatpickr as currently used by our components,
   * if additional options are needed, they will need to be added to this model.
   * Available options to be added can be found here: https://flatpickr.js.org/options/
   * When adding a new option to the flatpickr config you should also provide a default, as current implementations may rely on flatpickr defaults
   *
   * Hooks
   * Flatpickr provides event hooks in order to expose functionality.
   * Custom methods can be passed to these event hooks, to trigger behaviour on flatpicker events.
   * All hooks take the following parameters as arguments when invoked: selectedDates, dateStr and flatpickrInstance.
   *
   * The following hooks are currently supported in this config:
   *  @property {function} onValueUpdate - Function to be called in onValueUpdate hook provided by flatpickr
   *  @property {function} onChange - Function to be called in onChange hook provided by flatpickr
   *  @property {function} onClose - Function to be called in onChange hook provided by flatpickr
   *
   * Note: Any additional hooks can be added to the model as needed, and all hooks can be found here: https://flatpickr.js.org/events/
   *
   * Options
   * @property {String} altFormat - Exactly the same as date format, but for the altInput field
   * @property {Boolean} altInput - Show the user a readable date (as per altFormat), but return something totally different to the server.
   * @property {Boolean} allowInvalidPreload - Allows the preloading of an invalid date. When disabled, the field will be cleared if the provided date is invalid
   * @property {HTMLElement} appendTo - Element for the flatpickr instance to append the calendar to
   * @property {Boolean} clickOpens - Whether clicking on the input should open the picker
   * @property {String} dateFormat - A string of characters which are used to define how the date will be displayed in the input box.
   * @property {Number} dateTime - unix time code used for setting default date
   * @property {String} defaultDate - Sets the initial selected date(s).
   * @property {Boolean} enableTime - Enables time picker
   * @property {Function} formatDate - Custom date formatting function
   * @property {Object} locale - Object containing changes to locale of datepickr including range separator
   * @property {Number} minuteIncrement - Adjusts the step for the minute input (incl. scrolling)
   * @property {String} maxDate - The maximum date that a user can start picking from (inclusive).
   * @property {String} minDate - The minimum date that a user can start picking from (inclusive).
   * @property {String} mode - "single", "multiple", or "range"
   * @property {Boolean} noCalendar - Hides the day selection in calendar.
   * @property {string} position - Where the calendar is rendered relative to the input vertically and horizontally. In the format of "[vertical] [horizontal]". Vertical can be auto, above or below. Horizontal can be left, center or right. Defaults to auto
   * @property {Number} showMonths - The number of months to be shown at the same time when displaying the calendar.
   * @property {Boolean} wrap - custom elements and input groups
   */
  class FlatpickrConfig {
    constructor(_ref) {
      let {
        onValueUpdate,
        onChange,
        onClose,
        onOpen,
        altFormat,
        altInput = false,
        allowInvalidPreload = false,
        appendTo,
        clickOpens = true,
        dateFormat,
        defaultDate,
        enableTime = false,
        formatDate,
        locale = {
          rangeSeparator: ' - '
        },
        minuteIncrement = '5',
        maxDate,
        minDate,
        mode = 'single',
        noCalendar = false,
        position = 'auto',
        showMonths = 1,
        time_24hr = false,
        wrap = false
      } = _ref;
      (false && !(typeof onValueUpdate === 'function' || typeof onChange === 'function') && (0, _debug.assert)('Must provide one of onValueUpdate or onChange to FlatpickrConfig', typeof onValueUpdate === 'function' || typeof onChange === 'function'));
      this.onValueUpdate = onValueUpdate;
      this.onChange = onChange;
      this.onClose = onClose;
      this.onOpen = onOpen;
      this.altFormat = altFormat !== null && altFormat !== void 0 ? altFormat : dateFormat;
      this.altInput = altInput;
      this.appendTo = appendTo;
      this.allowInvalidPreload = allowInvalidPreload;
      this.clickOpens = clickOpens;
      this.dateFormat = dateFormat;
      this.locale = locale;
      this.defaultDate = defaultDate;
      this.enableTime = enableTime;
      this.formatDate = formatDate;
      this.minuteIncrement = minuteIncrement;
      this.maxDate = maxDate;
      this.minDate = minDate;
      this.mode = mode;
      this.noCalendar = noCalendar;
      this.position = position;
      this.showMonths = showMonths;
      this.time_24hr = time_24hr;
      this.wrap = wrap;
    }

  }

  _exports.default = FlatpickrConfig;
});